import {
    ResultObj,
    allFetch,
} from "../Domain";
import { RowData } from "../types";

/**
 * @description 試乘車列表(參數)
 * @param {string} license_plate 車牌
 * @param {string} location 地點
 * @param {string} ct_id 車型代碼
 * @param {string} remark 備註
 * @param {string} status 車輛狀態
 */
export interface TestDriveCarListParams {
    license_plate: string;
    location: string;
    ct_id: string;
    remark: string;
    status: string;
}

/**
 * @description 試乘車列表(回傳)
 * @param {string} license_plate 車牌
 * @param {string} tdc_id 試乘車編號
 * @param {string} status 車輛狀態
 * @param {string} location 地點
 * @param {string} ct_id 車型代碼
 * @param {string} cartype_name 車型名稱
 * @param {string} remark 備註
 * @param {string} ul_id 使用者層級流水號
 */
export interface TestDriveCarListResItem {
    license_plate: string;
    tdc_id: string;
    status: string;
    location: string;
    ct_id: string;
    cartype_name: string;
    remark: string;
    ul_id: string;
}
/**
 * @description 試乘車列表
 */
export const TestDriveCarList = async (
    obj: TestDriveCarListParams = {
        license_plate: '',
        location: '',
        ct_id: '',
        remark: '',
        status: '',
    },
): Promise<ResultObj<TestDriveCarListResItem[]>> => await allFetch("TestDrive/TestDriveCarList", obj);


/**
 * @description 新增試乘車(參數)
 * @param {string} license_plate 車牌
 * @param {string} location 地點
 * @param {string} ul_id 使用者層級流水號
 * @param {string} ct_id 車型代碼
 * @param {string} ctf_id 車型規格代碼
 * @param {string} ce_id 車型顏色代碼
 * @param {string} remark 備註
 * @param {string} status 車輛狀態 (記得檢查api可不可以WORK)
 */
export interface AddTestDriveCarParams {
    license_plate: string;
    location: string;
    ul_id: string;
    ct_id: string;
    ctf_id: string;
    ce_id: string;
    remark: string;
    status: string;
}
/**
 * @description 新增試乘車(回傳)
 * @param {string} tdc_id 車牌
 */
export interface AddTestDriveCarResItem {
    tdc_id: string;
}

/**
 * @description 新增試乘車
 */
export const AddTestDriveCar = async (
    obj: AddTestDriveCarParams = {
        license_plate: "",
        location: "",
        ul_id: "",
        ct_id: "",
        ctf_id: "",
        ce_id: "",
        remark: "",
        status: "",

    },
): Promise<ResultObj<AddTestDriveCarResItem>> => await allFetch("TestDrive/AddTestDriveCar", obj);

/**
 * @description 試乘車詳細資料(參數)
 * @param {string} tdc_id 試乘車編號
 */
export interface TestDriveCarEditParams {
    tdc_id: string;
}

/**
 * @description 試乘車詳細資料(回傳)
 * @param {string} status 車輛狀態  
 * @param {string} location 地點
 * @param {string} tdc_id 試乘車編號
 * @param {string} license_plate 車牌
 * @param {string} ct_id 車型代碼
 * @param {string} ctf_id 車型規格代碼
 * @param {string} ce_id 車型顏色代碼
 * @param {string} ul_id 使用者層級流水號
 * @param {string} remark 備註
 */
export interface TestDriveCarEditResItem {
    status: string;
    location: string;
    tdc_id: string;
    license_plate: string;
    ct_id: string;
    ctf_id: string;
    ce_id: string;
    ul_id: string;
    remark: string;
}

/**
 * @description 試乘車詳細資料
 */
export const TestDriveCarEdit = async (
    obj: TestDriveCarEditParams = {
        tdc_id: '',
    },
): Promise<ResultObj<TestDriveCarEditResItem>> => await allFetch("TestDrive/TestDriveCarEdit", obj);


/**
 * @description 更新試乘車(參數)
 * @param {string} tdc_id 試乘車編號
 * @param {string} location 地點
 * @param {string} ul_id 使用者層級流水號
 * @param {string} ct_id 車型代碼
 * @param {string} ctf_id 車型規格代碼
 * @param {string} ce_id 車型顏色代碼
 * @param {string} remark 備註
 * @param {string} status 車輛狀態  
 * 
 * 
 */
export interface UpdateTestDriveCarParams {
    tdc_id: string;
    location: string;
    ul_id: string;
    ct_id: string;
    ctf_id: string;
    ce_id: string;
    remark: string;
    status: string;
    license_plate: string;
}

/**
 * @description 更新試乘車
 */
export const UpdateTestDriveCar = async (
    obj: UpdateTestDriveCarParams = {
        tdc_id: '',
        location: '',
        ul_id: '',
        ct_id: '',
        ctf_id: '',
        ce_id: '',
        remark: '',
        status: '',
        license_plate: '',
    },
): Promise<ResultObj> => await allFetch("TestDrive/UpdateTestDriveCar", obj);


/**
 * @description 刪除試乘車(參數)
 * @param {string} tdc_id 試乘車編號
 */
export interface DeleteTestDriveCarParams {
    tdc_id: string;
}

/**
 * @description 刪除試乘車
 */
export const DeleteTestDriveCar = async (
    obj: DeleteTestDriveCarParams = {
        tdc_id: '',
    },
): Promise<ResultObj> => await allFetch("TestDrive/DeleteTestDriveCar", obj);



/**----------------------------------------------------------------------- */

/**
 * @description 試乘預約頁的 (參數)
 * @param {string} tdc_id 試乘車編號
 * @param {string} test_date 試乘日期
 * @param {string} test_time 試乘時間
 * @param {string} _user_id 使用者編號
 */
export interface TestDriveBookingParams {
    tdc_id: string;
    test_date: string;
    test_time: string;
    _user_id: string;
}


/**
 * @description 根據月份查詢試乘列表(參數)
 * @param {string} tdc_id 試乘車編號
 * @param {string} month 試乘月份
 * @param {string} user_id 使用者編號
 */
export interface TestDriveListByMonthParams {
    tdc_id: string;
    month: string;
    user_id: string;
}

/**
 * @description 根據月份查詢試乘列表(回傳)
 * @param {string} days 日期
 * @param {string} found 是否有資料
 */
export interface TestDriveListByMonthResItem {
    days: string;
    found: string;
}

/**
 * @description 根據月份查詢試乘列表
 */
export const TestDriveListByMonth = async (
    obj: TestDriveListByMonthParams = {
        tdc_id: '',
        month: '',
        user_id: ''
    },
): Promise<ResultObj<TestDriveListByMonthResItem[]>> => await allFetch("TestDrive/TestDriveListByMonth", obj);


/**
 * @description 根據日期查詢試乘列表(參數)
 * @param {string} tdc_id 試乘車編號
 * @param {string} test_date 試乘日期
 */
export interface TestDriveListByDayParams {
    tdc_id: string;
    test_date: string;
}

/**
 * @description 根據日期查詢試乘列表(回傳)
 * @param {string} tdc_id 試乘車編號
 * @param {string} td_id 試乘流水號
 * @param {string} user_id 帳號編號
 * @param {string} name 客戶名字
 * @param {string} test_date 試乘日期
 * @param {string} test_time 試乘時間
 * @param {string} cre_time 創建時間
 */
export interface TestDriveListByDayResItem {
    tdc_id: string;
    td_id: string;
    user_id: string;
    name: string;
    test_date: string;
    test_time: string;
    cre_time: string;

}

/**
 * @description 根據日期查詢試乘列表
 */
export const TestDriveListByDay = async (
    obj: TestDriveListByDayParams = {
        tdc_id: '',
        test_date: '',
    },
): Promise<ResultObj<TestDriveListByDayResItem[]>> => await allFetch("TestDrive/TestDriveListByDay", obj);



/**
 * @description 查詢試乘列表(參數)
 * @param {string} tdc_id 試乘車編號
 * @param {string} location 地點
 * @param {string} license_plate 車牌
 * @param {string} start_date 開始日期
 * @param {string} end_date 結束日期
 * @param {string} _user_id 使用者編號
 * @param {string} user_name 使用者名字
 * @param {string} excel_status 匯出EXCEL(預設false)
 */
export interface TestDriveListParams {
    tdc_id: string;
    location: string;
    license_plate: string;
    start_date: string;
    end_date: string;
    _user_id: string;
    user_name: string;
    excel_status: string;
}

/**
 * @description 查詢試乘列表(回傳)
 * @param {string} location 地點
 * @param {string} license_plate 車牌
 * @param {string} tdc_id 試乘車編號
 * @param {string} CarType_name 車型名稱
 * @param {string} CarType_format_name 車型規格名稱
 * @param {string} user_name 使用者名字
 * @param {string} test_datetime 測試時間
 * @param {string} name 客戶名字
 * @param {string} gender 性別
 * @param {string} remark 備註
 * @param {string} td_id 試乘流水號
 */
export interface TestDriveListResItem {
    location: string;
    license_plate: string;
    tdc_id: string;
    CarType_name: string;
    CarType_format_name: string;
    user_name: string;
    test_datetime: string;
    name: string;
    gender: string;
    remark: string;
    td_id: string;
}

/**
 * @description 查詢試乘列表
 */
export const TestDriveList = async (
    obj: TestDriveListParams = {
        tdc_id: '',
        location: '',
        license_plate: '',
        start_date: '',
        end_date: '',
        _user_id: '',
        user_name: '',
        excel_status: ''
    },
): Promise<ResultObj<TestDriveListResItem[]>> => await allFetch("TestDrive/TestDriveList", obj);












/**
 * @description 使用控制板新增試乘紀錄(參數)
 * @param {string} tdc_id 試乘車編號
 * @param {string} test_date 試乘日期
 * @param {string} test_time 試乘時間
 * @param {string} _user_id 使用者編號
 */
export interface AddTestDriveFromDashboardParams {
    tdc_id: string;
    test_date: string;
    test_time: string;
    _user_id: string;
}

/**
 * @description 使用控制板新增試乘紀錄(回傳)
 * @param {string} td_id 試乘編號
 */
export interface AddTestDriveFromDashboardResItem {
    td_id: string;
}

/**
 * @description 使用控制板新增試乘紀錄
 */
export const AddTestDriveFromDashboard = async (
    obj: AddTestDriveFromDashboardParams = {
        tdc_id: '',
        test_date: '',
        test_time: '',
        _user_id: ''
    },
): Promise<ResultObj<AddTestDriveFromDashboardResItem>> => await allFetch("TestDrive/AddTestDriveFromDashboard", obj);


/**
 * @description 使用控制板刪除試乘紀錄(參數)
 * @param {string} tdc_id 試乘車編號
 * @param {string} test_date 試乘日期
 * @param {string} test_time 試乘時間
 * @param {string} _user_id 使用者編號
 */
export interface DeleteTestDriveFromDashBoardParams {
    tdc_id: string;
    test_date: string;
    test_time: string;
    _user_id: string;
}

/**
 * @description 使用控制板刪除試乘紀錄
 */
export const DeleteTestDriveFromDashBoard = async (
    obj: AddTestDriveFromDashboardParams = {
        tdc_id: '',
        test_date: '',
        test_time: '',
        _user_id: ''
    },
): Promise<ResultObj> => await allFetch("TestDrive/DeleteTestDriveFromDashBoard", obj);






















/**
 * @description 使用控制板新增試乘紀錄以日期為單位(參數)
 * @param {string} tdc_id 試乘車編號
 * @param {string} test_date 試乘日期
 * @param {string} _user_id 使用者編號
 */
export interface AddTestDriveAllDayFromDashboardParams {
    tdc_id: string;
    test_date: string;
    _user_id: string;
}

/**
 * @description 使用控制板新增試乘紀錄以日期為單位(回傳)
 * @param {string} td_id 試乘編號
 */
export interface AddTestDriveAllDayFromDashboardResItem {
    td_id: string;
}

/**
 * @description 使用控制板新增試乘紀錄以日期為單位
 */
export const AddTestDriveAllDayFromDashboard = async (
    obj: AddTestDriveAllDayFromDashboardParams = {
        tdc_id: '',
        test_date: '',
        _user_id: ''
    },
): Promise<ResultObj<AddTestDriveAllDayFromDashboardResItem>> => await allFetch("TestDrive/AddTestDriveAllDayFromDashboard", obj);




/**
 * @description 使用控制板刪除試乘記錄以日期為單位(參數)
 * @param {string} tdc_id 試乘車編號
 * @param {string} test_date 試乘日期
 * @param {string} _user_id 使用者編號
 */
export interface DeleteTestDriveAllDayFromDashboardParams {
    tdc_id: string;
    test_date: string;
    _user_id: string;
}
/**
 * @description 使用控制板刪除試乘記錄以日期為單位
 */
export const DeleteTestDriveAllDayFromDashboard = async (
    obj: DeleteTestDriveAllDayFromDashboardParams = {
        tdc_id: '',
        test_date: '',
        _user_id: ''
    },
): Promise<ResultObj> => await allFetch("TestDrive/DeleteTestDriveAllDayFromDashboard", obj);





/**
 * @description 使用控制板更新試乘紀錄(參數)
 * @param {string} td_id_list 試乘流水號
 * @param {string} name 試乘車編號
 * @param {string} gender 試乘日期
 * @param {string} remark 備註
 * @param {string} _user_id 使用者編號
 */
export interface UpdateTestDriveFromDashboardParams {
    td_id_list: string[]
    name: string;
    gender: string;
    remark: string;
    _user_id: string;
}
/**
 * @description 使用控制板更新試乘紀錄
 */
export const UpdateTestDriveFromDashboard = async (
    obj: UpdateTestDriveFromDashboardParams = {
        td_id_list: [''],
        name: '',
        gender: '',
        remark: '',
        _user_id: ''
    },
): Promise<ResultObj> => await allFetch("TestDrive/UpdateTestDriveFromDashboard", obj);




/**
 * @description 試乘列表的EXCEL(參數)
 * @param {string} location 地點
 * @param {string} license_plate 車牌
 * @param {string} start_date 開始日期
 * @param {string} end_date 結束日期
 * @param {string} _user_id 使用者流水號
 * @param {string} user_name 使用者名字
 */
export interface TestDriveListExportParams {
    location: string;
    license_plate: string;
    start_date: string;
    end_date: string;
    _user_id: string;
    user_name: string;
}

/**
 * @description 試乘列表的EXCEL(回傳)
 * @param {string} path 路徑
 */
export interface TestDriveListExportResItem {
    path: string;
}

/**
 * @description 試乘列表的EXCEL
 */
export const TestDriveListExport = async (
    obj: TestDriveListExportParams = {
        location: '',
        license_plate: '',
        start_date: '',
        end_date: '',
        _user_id: '',
        user_name: ''
    },
): Promise<ResultObj<TestDriveListExportResItem>> => await allFetch("TestDrive/TestDriveListExport", obj);











// ----------------------------------------------------------------



/**
 * @description 以使用者為單位產生試乘報表(參數)
 * @param {string} start_date 開始日期
 * @param {string} end_date 結束日期
 */
export interface TestDriveReportByUserParams {
    start_date: string;
    end_date: string;
}

/**
 * @description 以使用者為單位產生試乘報表
 */
export const TestDriveReportByUser = async (
    obj: TestDriveReportByUserParams = {
        start_date: '',
        end_date: '',
    },
): Promise<ResultObj> => await allFetch("TestDrive/TestDriveReportByUser", obj);


/**
 * @description 以車輛為單位產生試乘報表(參數)
 * @param {string} start_date 開始日期
 * @param {string} end_date 結束日期
 */
export interface TestDriveReportByCarParams {
    start_date: string;
    end_date: string;
}

/**
 * @description 以車輛為單位產生試乘報表
 */
export const TestDriveReportByCar = async (
    obj: TestDriveReportByCarParams = {
        start_date: '',
        end_date: '',
    },
): Promise<ResultObj> => await allFetch("TestDrive/TestDriveReportByCar", obj);





/**
 * @description 以使用者為單位產生試乘細項報表(參數)
 * @param {string} start_date 開始日期
 * @param {string} end_date 結束日期
 * @param {string} _user_id 使用者流水號
 */
export interface TestDriveReportDetailByUserParams {
    start_date: string;
    end_date: string;
    _user_id: string
}
/**
 * @description 以使用者為單位產生試乘細項報表(回傳)
 * @param {string} test_date 測試日期
 * @param {string} license_plate 車牌
 * @param {string} CarType_name 車型名稱
 * @param {string} CarType_format_name 車型規格名稱
 * @param {string} _count 次數
 */
export interface TestDriveReportDetailByUserResItem {
    test_date: string;
    license_plate: string;
    CarType_name: string;
    CarType_format_name: string;
    _count: string;
}

/**
 * @description 以使用者為單位產生試乘細項報表
 */
export const TestDriveReportDetailByUser = async (
    obj: TestDriveReportDetailByUserParams = {
        start_date: '',
        end_date: '',
        _user_id: ''
    },
): Promise<ResultObj<TestDriveReportDetailByUserResItem[]>> => await allFetch("TestDrive/TestDriveReportDetailByUser", obj);



/**
 * @description 以車為單位產生試乘報表(參數)
 * @param {string} start_date 開始日期
 * @param {string} end_date 結束日期
 * @param {string} license_plate 車牌
 */
export interface TestDriveReportDetailByCarParams {
    start_date: string;
    end_date: string;
    license_plate: string
}
/**
 * @description 以車為單位產生試乘報表(回傳)
 * @param {string} test_date 測試日期
 * @param {string} name 客戶姓名
 * @param {string} gender 客戶性別
 * @param {string} _count 次數
 */
export interface TestDriveReportDetailByCarResItem {
    test_date: string;
    name: string;
    gender: string;
    _count: string;
}

/**
 * @description 以車為單位產生試乘報表
 */
export const TestDriveReportDetailByCar = async (
    obj: TestDriveReportDetailByCarParams = {
        start_date: '',
        end_date: '',
        license_plate: ''
    },
): Promise<ResultObj<TestDriveReportDetailByCarResItem[]>> => await allFetch("TestDrive/TestDriveReportDetailByCar", obj);






/**
 * @description 以使用者為單位產生試乘細項報表EXCEL(參數)
 * @param {string} start_date 開始日期
 * @param {string} end_date 結束日期
 * @param {string} _user_id 使用者流水號
 */
export interface TestDriveReportDetailExportByUserParams {
    start_date: string;
    end_date: string;
    _user_id: string
}

/**
 * @description 以使用者為單位產生試乘細項報表EXCEL
 */
export const TestDriveReportDetailExportByUser = async (
    obj: TestDriveReportDetailExportByUserParams = {
        start_date: '',
        end_date: '',
        _user_id: ''
    },
): Promise<ResultObj> => await allFetch("TestDrive/TestDriveReportDetailExportByUser", obj);





/**
 * @description 以車為單位產生試乘細項報表EXCEL(參數)
 * @param {string} start_date 開始日期
 * @param {string} end_date 結束日期
 * @param {string} license_plate 車牌
 */
export interface TestDriveReportDetailExportByCarParams {
    start_date: string;
    end_date: string;
    license_plate: string
}

/**
 * @description 以車為單位產生試乘細項報表EXCEL
 */
export const TestDriveReportDetailExportByCar = async (
    obj: TestDriveReportDetailExportByCarParams = {
        start_date: '',
        end_date: '',
        license_plate: ''
    },
): Promise<ResultObj> => await allFetch("TestDrive/TestDriveReportDetailExportByCar", obj);










/**
 * @description 以人為單位產生試乘圖表(參數)
 * @param {string} start_date 開始日期
 * @param {string} end_date 結束日期
 * @param {string} license_plate_list 車牌列表
 */
export interface TestDriveChartByUserParams {
    start_date: string;
    end_date: string;
    license_plate_list: string[];
    __user_id: string
}

/**
 * @description 以人為單位產生試乘圖表(回傳)
 * @param {string} license_plate 車牌
 * @param {string} CarType_name 車型名稱
 * @param {string} CarType_name_format 車型規格名稱
 * @param {string} all_count 預約總數
 * @param {string} name 客戶姓名
 * @param {string} gender 客戶性別
 * @param {string} customer_count 預約次數
 */
export interface TestDriveChartByUserResItem {
    license_plate: string;
    CarType_name: string;
    CarType_name_format: string;
    all_count: string;
    children:
    {
        name: string;
        gender: string;
        customer_count: string;
    }[]

}
/**
 * @description 以人為單位產生試乘圖表
 */
export const TestDriveChartByUser = async (
    obj: TestDriveChartByUserParams = {
        start_date: '',
        end_date: '',
        license_plate_list: [],
        __user_id: ''
    },
): Promise<ResultObj<TestDriveChartByUserResItem[]>> => await allFetch("TestDrive/TestDriveChartByUser", obj);
